// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"HeatMap__wrapper___2SbIy","image":"HeatMap__image___14LMZ","withOverlay":"HeatMap__withOverlay___Roo0h","heatmap":"HeatMap__heatmap___3CqGM","heatmapSelection":"HeatMap__heatmapSelection___2gEf9","hideRegion":"HeatMap__hideRegion___osJ54","showRegion":"HeatMap__showRegion___1oV_w","heatmapSelectionRemove":"HeatMap__heatmapSelectionRemove___2Zkmo","default":"HeatMap__default___2Zq5T","regionAtBottom":"HeatMap__regionAtBottom___16Y_y","removeXIcon":"HeatMap__removeXIcon___1kShi","heatmapSelectionOverlay":"HeatMap__heatmapSelectionOverlay___rf0it"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/HeatMap.css
// module id = 1558
// module chunks = 0